import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { StudentCompactItem } from '../../models/student.models';
import { getInitials } from '../../utils/name.utils';

@Component({
  standalone: true,
  selector: 'app-student-compact-view',
  imports: [CommonModule],
  templateUrl: './student-compact-view.component.html',
  styleUrl: './student-compact-view.component.scss',
})
export class StudentCompactViewComponent {
  item = input.required<StudentCompactItem>();

  getInitials = getInitials;

  hasAvatar(): boolean {
    return !!(this.item()?.avatarUrl && this.item()?.avatarUrl.trim() !== '');
  }
}
